
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        $('.page').outerHeight($(window).height());

        $('[data-simplebar]').mCustomScrollbar();

        $('.category-dyskografia, .category-discography').on('click', '.popup .close', function() {
          var $popup = $(this).parents('.popup'),
          $albums = $('article');
          $popup.velocity({
              opacity: 0,
            }, {
              display: 'none'
            }
          );
          $albums.velocity({
              opacity: 1,
            }
          );
        });

        $('.album .more').on('click', function() {
          var $popup = $(this).parents('article').next('.popup'),
          $albums = $('article');
          $popup.velocity({
              opacity: 1,
            }, {
              display: 'block'
            }
          );
          $albums.velocity({
              opacity: 0,
            }
          );
        });

        if ( $('.gallery').length > 0 ) {
          $('.gallery .gallery-item a').on('click', function() {
            var $popup = $('<div class="popup"></div>'),
            $gallery = $('.gallery'),
            $slick = $('<div class="slick-slider"></div>'),
            $close = $('<button class="close"><i class="icon-close"></i></button>'),
            eq = $(this).parents('.gallery-item').index();

            $('body').addClass('popupVisible');
            // Close button
            $popup.append($close);
            $close.on('click', function() {
              $popup.velocity('stop').velocity({
                opacity: 0
              }, {
                display: 'none'
              });
              $gallery.velocity({
                  opacity: 1,
                }, {
                  complete: function() {
                    $popup.remove();
                  }
                }
              );
              $('body').removeClass('popupVisible');
            });

            // Create gallery
            $('.gallery').find('a').each(function() {
              var img = $('<img />', {
                id: 'Myid',
                src: $(this).attr('href'),
                alt: 'MyAlt'
              });
              var div = $('<div></div>').append(img);
              $slick.append( div );
            });

            $popup.append($slick);
            $('.gallery').after($popup);
            $popup.velocity({
                opacity: 1,
              }, {
                begin: function(elements) {
                  $popup.css('display', 'block');
                  $slick.slick({
                    prevArrow: '<button type="button" class="slick-prev"><i class="icon-slider-prev"></i></button>',
                    nextArrow: '<button type="button" class="slick-next"><i class="icon-slider-next"></i></button>',
                    initialSlide: eq
                  });
                }
              }
            );
            $gallery.velocity({
                opacity: 0,
              }
            );
            return false;
          });
        }
        var navStatus = false;
        $('.nav-toggle').on('click', function() {
          $(this).toggleClass('active');
          if ( !navStatus ) {
            $('.nav-primary').velocity({ opacity: 1 }, { display: "flex" });
            navStatus = true;
          } else {
            $('.nav-primary').velocity({ opacity: 0 }, { display: "none" });
            navStatus = false;
          }
        });

        var marker = $('#marker'),
        leftPos = $('.current-menu-item a').position().left + ($('.current-menu-item a').outerWidth() / 2);
        marker.css('left', leftPos);

        $('.nav-primary').on('mouseenter', 'a', function() {
          var marker = $('#marker'),
          leftPosThis = $(this).position().left + ($(this).outerWidth() / 2);

          marker.velocity('stop').velocity({
            left: leftPosThis
          }, 'easeOutQuad');
        }).on('mouseleave', '.nav', function() {
          marker.velocity('stop').velocity({
            left: leftPos
          }, 'easeOutQuad');
        });


        var $lines = $('.lines');
        $lines.each(function() {
          var $line = $(this);
          $(this).velocity({
            translateX: [0, '-100%']
          }, {
            easing: 'easeOutQuad',
            duration: 2000,
            complete: function() {
              var spanLength = $line.find('span').length;
              $line.find('span').each(function(index) {
                $(this).velocity({
                  opacity: 1
                }, {
                  easing: 'easeOutQuad',
                  duration: 2000,
                  delay: 500 * index
                })
              });
              var scene = $(this)[0];
              var parallax = new Parallax(scene);
            }
          });
        });

        if ( $('#parallax').length > 0 ) {
          var scene = document.getElementById('parallax');
          var parallax = new Parallax(scene);
        }
        $('.home-animate').velocity({
          translateY: [0, '20%'],
          opacity: 1
        }, {
          easing: 'easeOutQuad',
          duration: 1000,
          delay: 3000
        });


        function getRandomInt(min, max) {
          min = Math.ceil(min);
          max = Math.floor(max);
          return Math.floor(Math.random() * (max - min)) + min;
        }


        // Animations

        $('.wrap .animated').each(function(index) {
          $(this).velocity({
            translateY: [0, '20%'],
            opacity: 1
          }, {
            easing: 'easeOutQuad',
            duration: 2000,
            delay: 500 * index
          });
        })
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

(function() {
  var __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  this.AudioPlayer = (function() {
    AudioPlayer.States = {
      Ready: 0,
      Playing: 1,
      Loading: 2,
      Error: 3
    };

    AudioPlayer.prototype.audioPlayerEvents = ["abort", "error", "play", "playing", "seeked", "pause", "ended", "canplay", "loadstart", "loadeddata", "canplaythrough", "seeking", "stalled", "waiting", "progress"];

    function AudioPlayer(options) {
      this.setOptions(options);
    }

    AudioPlayer.prototype.setOptions = function(options) {
      var key, value;
      if (options == null) {
        options = {};
      }
      for (key in options) {
        value = options[key];
        this[key] = value;
      }
      if (options.el) {
        return this.setEl(options.el);
      }
    };

    AudioPlayer.prototype.setEl = function(el) {
      if (this.el) {
        this._unbindEvents();
      }
      this.el = el;
      return this._bindEvents();
    };

    AudioPlayer.prototype.updateState = function(e) {
      var state, _ref;
      state = this.isErrored() ? AudioPlayer.States.Error : this.isLoading() ? AudioPlayer.States.Loading : this.isPlaying() ? AudioPlayer.States.Playing : AudioPlayer.States.Ready;
      if (this.state !== state) {
        this.state = state;
        return (_ref = this.ui) != null ? _ref.AudioPlayerUpdateState(state) : void 0;
      }
    };

    AudioPlayer.prototype.isPlaying = function() {
      return this.el && !this.el.paused;
    };

    AudioPlayer.prototype.isPaused = function() {
      return this.el && this.el.paused;
    };

    AudioPlayer.prototype.isLoading = function() {
      if (!this.state && this.isEmpty()) {
        return false;
      }
      return this.el.networkState === this.el.NETWORK_LOADING && this.el.readyState < this.el.HAVE_FUTURE_DATA;
    };

    AudioPlayer.prototype.isErrored = function() {
      return this.el.error || this.el.networkState === this.el.NETWORK_NO_SOURCE;
    };

    AudioPlayer.prototype.isEmpty = function() {
      return this.el.readyState === this.el.HAVE_NOTHING;
    };

    AudioPlayer.prototype.isEnded = function() {
      return this.el.ended;
    };

    AudioPlayer.prototype.play = function() {
      var _ref;
      if (this.isEmpty()) {
        if ((_ref = this.ui) != null) {
          _ref.AudioPlayerUpdateState(AudioPlayer.States.Loading);
        }
      }
      return this.el.play();
    };

    AudioPlayer.prototype.pause = function() {
      return this.el.pause();
    };

    AudioPlayer.prototype.load = function() {
      return this.el.load();
    };

    AudioPlayer.prototype.duration = function() {
      return this.el.duration;
    };

    AudioPlayer.prototype.seekTo = function(time) {
      return this.el.currentTime = parseInt(time, 10);
    };

    AudioPlayer.prototype.percentComplete = function() {
      var number;
      number = ~~((this.el.currentTime / this.el.duration) * 10000);
      return number / 10000;
    };

    AudioPlayer.prototype.handleEvent = function(event) {
      var _ref;
      if (_ref = event.type, __indexOf.call(this.audioPlayerEvents, _ref) >= 0) {
        return this.updateState(event);
      } else if (event.type === "timeupdate") {
        return this._timeUpdate(event);
      }
    };

    AudioPlayer.prototype.destroy = function() {
      this.ui = null;
      return this._unbindEvents();
    };

    AudioPlayer.prototype._bindEvents = function() {
      var eventName, _i, _len, _ref;
      _ref = this.audioPlayerEvents;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        eventName = _ref[_i];
        this.el.addEventListener(eventName, this);
      }
      return this.el.addEventListener("timeupdate", this);
    };

    AudioPlayer.prototype._unbindEvents = function() {
      var eventName, _i, _len, _ref;
      _ref = this.audioPlayerEvents;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        eventName = _ref[_i];
        this.el.removeEventListener(eventName, this);
      }
      return this.el.removeEventListener("timeupdate", this);
    };

    AudioPlayer.prototype._timeUpdate = function(e) {
      var _ref;
      if (!this.isLoading()) {
        return (_ref = this.ui) != null ? typeof _ref.AudioPlayerTimeUpdated === "function" ? _ref.AudioPlayerTimeUpdated(this.percentComplete()) : void 0 : void 0;
      }
    };

    return AudioPlayer;

  })();

  this.AudioPlayerUI = (function() {
    AudioPlayerUI.prototype.transitionEvents = ["transitionend", "webkitTransitionEnd", "MSTransitionEnd", "oTransitionEnd"];

    function AudioPlayerUI(options) {
      if (options == null) {
        options = {};
      }
      this.setOptions(options);
      this.audioPlayer = new AudioPlayer({
        ui: this
      });
      this._createAudioEl();
      // this._createImageEl();
      if (options.el) {
        this.setEl(options.el);
      }
      this.goToSong(0);
    }

    AudioPlayerUI.prototype.setOptions = function(options) {
      var key, value, _results;
      _results = [];
      for (key in options) {
        value = options[key];
        _results.push(this[key] = value);
      }
      return _results;
    };

    AudioPlayerUI.prototype.setEl = function(el) {
      this._unbindEvents();
      this.el = el;
      this.$el = jQuery(this.el);
      this.$el.append(this.audioEl);
      // this.$imageContainer = this.$el.find(".audio-player-image");
      // this.$imageContainer.append(this.image);
      this.$progressContainer = this.$el.find(".audio-player-progress");
      this.$progressBar = this.$el.find(".audio-player-progress-bar");
      this.$button = this.$el.find(".audio-player-place-pause-button");
      this.$backButton = this.$el.find(".icon-backward");
      this.$nextButton = this.$el.find(".icon-forward");
      this.$name = this.$el.find(".audio-player-song-name");
      return this._bindEvents();
    };

    AudioPlayerUI.prototype.togglePlayPause = function() {
      if (this.audioPlayer.isPlaying()) {
        return this.audioPlayer.pause();
      } else {
        return this.audioPlayer.play();
      }
    };

    AudioPlayerUI.prototype.goToSong = function(index) {
      var wasPlaying;
      this.currentSong = index;
      wasPlaying = this.audioPlayer.isPlaying();
      this._updateSourceAttributes(index);
      // this._updateImageAttributes(index);
      this.$name[0].innerHTML = this.songs[index].name;
      this.audioPlayer.setEl(this.audioEl);
      this.$progressBar.css({
        width: 0
      });
      this.audioPlayer.load();
      if (wasPlaying) {
        return this.audioPlayer.play();
      }
    };

    AudioPlayerUI.prototype.nextSong = function() {
      if (this.currentSong === this.songs.length - 1) {
        return this.goToSong(0);
      } else {
        return this.goToSong(this.currentSong + 1);
      }
    };

    AudioPlayerUI.prototype.previousSong = function() {
      if (this.currentSong === 0) {
        return this.goToSong(this.songs.length - 1);
      } else {
        return this.goToSong(this.currentSong - 1);
      }
    };

    AudioPlayerUI.prototype.seek = function(e) {
      var duration, offset, percent, seekTo, _ref;
      if (offset = e.offsetX || ((_ref = e.originalEvent) != null ? _ref.layerX : void 0)) {
        percent = offset / this.$progressContainer.width();
        duration = this.audioPlayer.duration();
        seekTo = duration * percent;
        return this.audioPlayer.seekTo(seekTo);
      }
    };

    AudioPlayerUI.prototype.AudioPlayerUpdateState = function() {
      this.$el.toggleClass("error", this.audioPlayer.isErrored());
      this.$progressContainer.toggleClass("loading", this.audioPlayer.isLoading());
      if (this.audioPlayer.isPlaying()) {
        this.$button.removeClass("icon-play").addClass("icon-pause");
      } else {
        this.$button.removeClass("icon-pause").addClass("icon-play");
      }
      if (this.audioPlayer.isEnded() && this.currentSong !== this.songs.length - 1) {
        this.nextSong();
        return this.audioPlayer.play();
      }
    };

    AudioPlayerUI.prototype.AudioPlayerTimeUpdated = function(percentComplete) {
      return this.$progressBar.css({
        width: "" + (percentComplete * 100) + "%"
      });
    };

    // AudioPlayerUI.prototype._createImageEl = function() {
    //   return this.image = document.createElement("img");
    // };

    AudioPlayerUI.prototype._createAudioEl = function() {
      return this.audioEl = document.createElement("audio");
    };

    AudioPlayerUI.prototype._updateSourceAttributes = function(index) {
      var source, sourceEl, _i, _len, _ref, _results;
      while (this.audioEl.firstChild) {
        this.audioEl.removeChild(this.audioEl.firstChild);
      }
      _ref = this.songs[index].srcs;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        source = _ref[_i];
        sourceEl = document.createElement("source");
        sourceEl.setAttribute("src", source.src);
        sourceEl.setAttribute("type", source.type);
        _results.push(this.audioEl.appendChild(sourceEl));
      }
      return _results;
    };

    // AudioPlayerUI.prototype._updateImageAttributes = function(index) {
    //   var callback, secondImage;
    //   callback = (function(_this) {
    //     return function() {
    //       _this.image.removeAttribute("class");
    //       jQuery(_this.image).off(_this.transitionEvents.join(" "));
    //       _this.image.setAttribute("src", _this.songs[index].image);
    //       return setTimeout(function() {
    //         if (secondImage) {
    //           return _this.$imageContainer[0].removeChild(secondImage);
    //         }
    //       }, 500);
    //     };
    //   })(this);
    //   if (this.$imageContainer && this.image.getAttribute("src")) {
    //     secondImage = document.createElement("img");
    //     secondImage.setAttribute("src", this.songs[index].image);
    //     this.image.setAttribute("class", "fading");
    //     this.$imageContainer.append(secondImage);
    //     return $(this.image).on(this.transitionEvents.join(" "), callback);
    //   } else {
    //     return callback();
    //   }
    // };

    AudioPlayerUI.prototype._bindEvents = function() {
      this.$button.on("click", jQuery.proxy(this, "togglePlayPause"));
      this.$backButton.on("click", jQuery.proxy(this, "previousSong"));
      this.$nextButton.on("click", jQuery.proxy(this, "nextSong"));
      return this.$progressContainer.on("mouseup", jQuery.proxy(this, "seek"));
    };

    AudioPlayerUI.prototype._unbindEvents = function() {
      var _ref, _ref1, _ref2, _ref3;
      if ((_ref = this.$button) != null) {
        _ref.off("click", this.togglePlayPause);
      }
      if ((_ref1 = this.$backButton) != null) {
        _ref1.off("click", this.previousSong);
      }
      if ((_ref2 = this.$nextButton) != null) {
        _ref2.off("click", this.nextSong);
      }
      return (_ref3 = this.$progressContainer) != null ? _ref3.off("mouseup", this.seek) : void 0;
    };

    return AudioPlayerUI;

  })();

  this.audioPlayer = new AudioPlayerUI({
    el: document.getElementById("audio-player"),
    songs: [
      {
        name: "First love",
        srcs: [
          {
            src: "/wp-content/themes/lukaszpohl/First love_M.mp3",
            type: "audio/mp3"
          }
        ]
      }, {
        name: "Fulfilled love",
        srcs: [
          {
            src: "/wp-content/themes/lukaszpohl/Fulfilled love_M.mp3",
            type: "audio/mp3"
          }
        ]
      }
    ]
  });

}).call(this);
